// src/pages/DriveTeamJoin.tsx
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import JoinFlow from "../components/aiTalentDrive/JoinFlow";
import "../styles/hiring-circuit.css";
import "../styles/drive-team-join.css";

/*
 * AI Talent Drive: a company adds its own recruiters
 * (/ai-talent-drive/join/<token>)
 *
 * The shareable link Babblebots hands to hiring companies. The flow itself
 * is components/aiTalentDrive/JoinFlow.tsx, shared with the sign-in form on
 * /ai-talent-drive/hiring-companies; this page only gives it the token
 * from the URL and the page chrome.
 */

export default function DriveTeamJoin() {
  const { token = "" } = useParams<{ token: string }>();

  return (
    <div className="hc-root tj-root">
      <Helmet>
        <title>Add your hiring team | AI Talent Drive | Babblebots</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <div className="board-bg" aria-hidden="true">
        <span className="bg-orb bg-orb-a" />
        <span className="bg-orb bg-orb-b" />
        <span className="bg-orb bg-orb-c" />
        <span className="bg-sparks" />
      </div>

      <div className="wrap">
        <JoinFlow token={token} />
      </div>
    </div>
  );
}
